export const addStationConstants = {
    
    // ADD_STATION_API: "/charging-station",

    ADD_AMENITIES_SAGA: "ADD_AMENITIES_SAGA",
    ADD_AMENITIES_REQUEST: "ADD_AMENITIES_REQUEST",
    ADD_AMENITIES_RESPONSE: "ADD_AMENITIES_RESPONSE",
    ADD_AMENITIES_API: "/charging-station/add-amenity",
 
    ADD_STATION_SAGA: "ADD_STATION_SAGA",
    ADD_STATION_REQUEST: "ADD_STATION_REQUEST",
    ADD_STATION_RESPONSE: "ADD_STATION_RESPONSE",
    ADD_STATION_API: "/charging-station",

    REMOVE_AMENITIES_SAGA: "REMOVE_AMENITIES_SAGA",
    REMOVE_AMENITIES_REQUEST: "REMOVE_AMENITIES_REQUEST",
    REMOVE_AMENITIES_RESPONSE: "REMOVE_AMENITIES_RESPONSE",
    REMOVE_AMENITIES_API: "/charging-station/remove-amenity",
 
    
};
